import { LinkOpenIcon, type TypeTableColumn } from '@thefarmersfront/kitchen';

import { TextButtonCell } from '~/components/common';

import type { TypeOrderDetailDeliveryInfoData } from '~/types/order.types';

/**
 * [출고주문관리 > 출고 주문 상세] '배송 정보' 테이블
 */
const getOrderDetailDeliveryInfoColumnDefs = () => {
  const columnDefs: TypeTableColumn<TypeOrderDetailDeliveryInfoData>[] = [
    {
      accessorKey: 'invoiceNumber',
      header: '송장번호',
      size: 240,
    },
    {
      accessorKey: 'operation',
      header: '배송유형',
      size: 80,
    },
    {
      accessorKey: 'courier',
      header: '배송사',
      size: 88,
    },
    {
      accessorKey: 'deliveryStatus',
      header: '배송상태',
      size: 100,
    },
    {
      accessorKey: 'url',
      header: '',
      minSize: 240,
      meta: { flex: true },
      cell: ({ getValue }) => {
        const url = getValue<string | null | undefined>();
        return (
          <TextButtonCell
            value={url}
            target="_blank"
            href={url ?? undefined}
            rightIcon={<LinkOpenIcon size={16} color="#672091" />}
          >
            배송조회
          </TextButtonCell>
        );
      },
    },
  ];

  return { columnDefs };
};

export default getOrderDetailDeliveryInfoColumnDefs;
